let language = {
    RETURNS_LIST_OPERATION: "Operation",
    RETURNS_LIST_RETURN: "Return No.",
    RETURNS_LIST_ORDER: "Order No.",
    RETURNS_LIST_TIME: "Application Time",
    RETURNS_LIST_STATUS: "Status",
    RETURNS_LIST_OPTIONS: "Options",
    RETURNS_LIST_CANCEL: "Cancel",
    RETURNS_LIST_DETAIL: "Detail",
    RETURNS_LIST_EXPRESS: "Submit Express",
    RETURNS_LIST_EMPTY: "Your return request is empty."
}

export { language }